window.myConsentManager = {
  COOKIE_CONSENT: 'CookieConsent_Shop',

  setCookie(value, days = 365) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${this.COOKIE_CONSENT}=${encodeURIComponent(value)}; path=/; expires=${expires}; SameSite=Lax; Secure`;
  },

  getConsentCookie() {
    const value = "; " + document.cookie;
    const parts = value.split("; " + this.COOKIE_CONSENT + "=");

    if (parts.length != 2) return {}

    try {
      const cookie = decodeURIComponent(parts.pop().split(";").shift());
      return JSON.parse(cookie);
    } catch {
      return {};
    }
  },

  get consents() {
    return this.getConsentCookie();
  },
  get states() {
    return this.getConsentCookie();
  },

  updateConsent(consent, value) {
    let cookie = this.getConsentCookie();
    cookie[consent] = value;
    this.setCookie(JSON.stringify(cookie));

    this.triggerUpdate();
  },

  _watchers: [],
  watch(callback) {
    this._watchers.push(callback);
  },

  triggerUpdate() {
    for (const cb of this._watchers) {
      if (cb.update) cb.update();
    }
  },

  saveAndApplyConsents() {
    this.triggerUpdate();
  },
};
